import React from "react"
import {
  Tooltip,
  Group,
  Text,
  ActionIcon,
  Anchor,
  Stack,
  Badge,
  Image,
} from "@mantine/core"
import { IconPencil } from "@tabler/icons-react"
import { API_URL } from "shared/config"
import { Link } from "react-router-dom"
import { PATHS } from "../../shared/lib/paths"
import { type Banner } from "../../shared/types/banner"
import { BannerActiveModal, BannerDeleteModal } from "../../features/banner"

// ----------------------------------------------------------------------

export function BannerTableRow(banner: Banner): React.JSX.Element {
  const { name, url, _id, image, isActive } = banner

  return (
    <tr>
      <td>
        <Group spacing="sm">
          <Stack spacing={6}>
            <Text fz="xl" fw={600}>
              {name}
            </Text>
            <Text>
              ССылка:{" "}
              <Anchor href={url} target="_blank">
                {url}
              </Anchor>
            </Text>
          </Stack>
        </Group>
      </td>
      <td>
        <Image
          maw={300}
          src={`${API_URL}/media/${image}`}
        />
      </td>
      <td>
        <Badge color={isActive ? "green" : "red"} fullWidth>
          {isActive ? "Да" : "Нет"}
        </Badge>
      </td>
      <td>
        <Group position="right" noWrap>
          <BannerActiveModal {...banner} />
          <Tooltip label="Редактировать">
            <ActionIcon
              radius="xl"
              size="xl"
              component={Link}
              to={PATHS.DASHBOARD.BANNERS.EDIT(_id)}
            >
              <IconPencil stroke={1.5}/>
            </ActionIcon>
          </Tooltip>
          <BannerDeleteModal {...banner} />
        </Group>
      </td>
    </tr>
  )
}
